import type { ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IIncidentCode, IIncidentCodesByGroup } from '@shared/services/incident-code-service';

@Component({
	selector: 'app-incident-code-select',
	templateUrl: './incident-code-select.component.html',
	styleUrl: './incident-code-select.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class IncidentCodeSelectComponent implements OnChanges {
	@Input() incidentCodesByGroup: IIncidentCodesByGroup[] = [];
	@Input() labelKey = '';
	@Input() errorKey = '';
	@Input() control!: FormControl<IIncidentCode | null>;
	@Output() selectionChange = new EventEmitter<IIncidentCode>();
	@ViewChild('incidentCodeFilterInput')
	incidentCodeFilterInput: ElementRef<HTMLInputElement>;

	filterControl = new FormControl('', { nonNullable: true });

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['incidentCodesByGroup']) {
			this.filterControl.setValue('');
		}
	}

	onOpenedChange(opened: boolean): void {
		if (opened) {
			setTimeout(() => this.incidentCodeFilterInput?.nativeElement?.focus());
		} else {
			this.filterControl.setValue('');
			this.control?.markAsTouched();
		}
	}

	get filteredIncidentCodesByGroup(): IIncidentCodesByGroup[] {
		const filter = this.filterControl.value.toLowerCase();
		if (!filter) {
			return this.incidentCodesByGroup ?? [];
		}
		return (this.incidentCodesByGroup ?? [])
			.map((group) => ({
				group: group.group,
				codes: group.codes.filter((code) => code.alias.toLowerCase().includes(filter) || code.name.toLowerCase().includes(filter)),
			}))
			.filter((group) => group.codes.length > 0);
	}

	get hasIncidentCodeOptions(): boolean {
		return (this.incidentCodesByGroup ?? []).some((group) => group.codes.length > 0);
	}
}
